<template>
    <div class="solicitud-pago-form">
        <v-dialog v-model="showForm" scrollable max-width="700">
            <v-card>
                <v-toolbar card prominent color="primary" dark dense>
                    <v-toolbar-title class="body-2">{{ this.formTitle }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="cancelForm()">
                        <v-icon medium>fa fa-close</v-icon>
                    </v-btn>
                    <template slot="extension">
                        <v-tabs color="primary darken-1" dark grow slider-color="yellow" v-model="activeTab">
                            <v-tab :key="1" :href="`#tab-1`">
                                Generales
                            </v-tab>
                            <v-tab :key="2" :href="`#tab-2`">
                                Pago
                            </v-tab>
                            <v-tab :key="3" :href="`#tab-3`">
                                Cuenta
                            </v-tab>
                        </v-tabs>
                    </template>
                </v-toolbar>

                <v-flex>
                    <div slot="widget-content">
                        <v-alert v-model="showErrorAlert" type="error" dismissible transition="scale-transition" dark>
                            Existen errores de validación, revise los datos e intente nuevamente
                        </v-alert>
                        <v-alert
                            v-model="showErrorDataLoadedAlert"
                            type="error"
                            dismissible
                            transition="scale-transition"
                            dark
                        >
                            No se han podido cargar todos los datos necesarios para este formulario, intente cargar el
                            formulario nuevamente.
                        </v-alert>
                    </div>
                </v-flex>

                <v-card-text>
                    <v-form ref="solicitudForm" v-model="isValidSolicitud">
                        <v-tabs-items v-model="activeTab">
                            <v-tab-item :key="1" :value="`tab-1`">
                                <v-container fluid grid-list-xl>
                                    <v-layout align-center wrap>
                                        <v-flex lg12 xs12 sm12>
                                            <v-text-field
                                                v-model="solicitudItem.nombre_solicitante"
                                                label="Solicitante*"
                                                :rules="nombre_solicitanteRules"
                                                :error-messages="nombre_solicitanteErrors"
                                                @blur="nombre_solicitanteErrors = []"
                                                :counter="255"
                                                ref="solicitante"
                                                name="solicitante"
                                                browser-autocomplete="solicitante"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex lg6 xs12 sm6>
                                            <v-menu
                                                ref="menuFechaSolicitud"
                                                v-model="menuFechaSolicitud"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                        v-model="computedFechaSolicitudFormatted"
                                                        label="Fecha de solicitud*"
                                                        :rules="fecha_solicitudRules"
                                                        :error-messages="fecha_solicitudErrors"
                                                        v-on="on"
                                                        readonly
                                                        @blur="
                                                            FechaSolicitud = parseDate(solicitudItem.fecha_solicitud)
                                                        "
                                                        @change="fecha_solicitudErrors = []"
                                                    >
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="FechaSolicitud"
                                                    no-title
                                                    scrollable
                                                    locale="es-es"
                                                    @input="menuFechaSolicitud = false"
                                                >
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex lg6 xs12 sm6>
                                            <v-menu
                                                ref="menuFechaPago"
                                                v-model="menuFechaPago"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                        v-model="computedFechaPagoFormatted"
                                                        label="Fecha de pago*"
                                                        :rules="fecha_pagoRules"
                                                        :error-messages="fecha_pagoErrors"
                                                        readonly
                                                        v-on="on"
                                                        @blur="FechaPago = parseDate(solicitudItem.fecha_pago)"
                                                        @change="fecha_entregaErrors = []"
                                                    >
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="FechaPago"
                                                    no-title
                                                    scrollable
                                                    locale="es-es"
                                                    @input="menuFechaPago = false"
                                                >
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex lg6 xs12 sm6>
                                            <v-select
                                                v-model="solicitudItem.campus_id"
                                                :items="CAMPUS"
                                                label="Campus*"
                                                item-text="nombre"
                                                item-value="id"
                                                :rules="campus_idRules"
                                                :error-messages="campus_idErrors"
                                                @blur="campus_idErrors = []"
                                                multiple
                                            >
                                            </v-select>
                                        </v-flex>
                                        <v-flex lg6 xs12 sm6>
                                            <v-select
                                                v-model="solicitudItem.departamento_id"
                                                :items="DEPARTAMENTOS"
                                                label="Departamento*"
                                                item-text="nombre"
                                                item-value="id"
                                                :rules="departamento_idRules"
                                                :error-messages="departamento_idErrors"
                                                @blur="departamento_idErrors = []"
                                            >
                                            </v-select>
                                        </v-flex>
                                        <v-flex lg6 xs12 sm4>
                                            <v-select
                                                v-model="solicitudItem.concepto_id"
                                                :items="
                                                    CONCEPTOS.filter(
                                                        el => el.departamento_id === solicitudItem.departamento_id
                                                    )
                                                "
                                                label="Concepto"
                                                item-text="nombre"
                                                item-value="id"
                                                :error-messages="concepto_idErrors"
                                                @blur="concepto_idErrors = []"
                                            >
                                            </v-select>
                                        </v-flex>
                                        <v-flex lg12 xs12 sm8>
                                            <v-text-field
                                                v-model="solicitudItem.descripcion"
                                                label="Descripción*"
                                                :rules="descripcionRules"
                                                :error-messages="descripcionErrors"
                                                @blur="descripcionErrors = []"
                                                :counter="255"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-tab-item>
                            <v-tab-item :key="2" :value="`tab-2`">
                                <v-container fluid grid-list-xl>
                                    <v-layout align-center wrap>
                                        <v-flex lg6 xs12 sm6>
                                            <v-select
                                                v-model="solicitudItem.tipo_monto_id"
                                                :items="MONTOS"
                                                label="Tipo de monto*"
                                                item-text="nombre"
                                                item-value="id"
                                                append-outer-icon="add"
                                                @click:append-outer="showTipoMontoForm = true"
                                                :rules="tipo_monto_idRules"
                                                :error-messages="tipo_monto_idErrors"
                                                @change="tipo_monto_idErrors = []"
                                            >
                                            </v-select>
                                        </v-flex>
                                        <v-flex lg6 xs12 sm6>
                                            <v-text-field
                                                v-model="solicitudItem.monto"
                                                label="Monto*"
                                                prefix="MX"
                                                type="number"
                                                min="0"
                                                :rules="montoRules"
                                                :error-messages="montoErrors"
                                                @blur="montoErrors = []"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex lg6 xs12 sm6>
                                            <v-select
                                                v-model="solicitudItem.forma_pago_id"
                                                :items="PAGOS"
                                                label="Forma de pago*"
                                                item-text="nombre"
                                                item-value="id"
                                                append-outer-icon="add"
                                                @click:append-outer="showFormaPagoForm = true"
                                                :rules="forma_pago_idRules"
                                                :error-messages="forma_pago_idErrors"
                                                @change="forma_pago_idErrors = []"
                                            >
                                                <template v-slot:item="data">
                                                    <v-list-tile-content>
                                                        <v-list-tile-title v-html="data.item.nombre">
                                                        </v-list-tile-title>
                                                        <v-list-tile-sub-title
                                                            v-html="forma_pago_tipos[data.item.tipo - 1]"
                                                        >
                                                        </v-list-tile-sub-title>
                                                    </v-list-tile-content>
                                                </template>
                                            </v-select>
                                        </v-flex>
                                        <v-flex lg6 xs12 sm6>
                                            <v-text-field
                                                v-model="solicitudItem.razon_o_nombre"
                                                label="Razón o nombre*"
                                                :rules="razon_o_nombreRules"
                                                :error-messages="razon_o_nombreErrors"
                                                @blur="razon_o_nombreErrors = []"
                                                :counter="255"
                                                ref="razon"
                                                name="razon"
                                                browser-autocomplete="razon"
                                            >
                                            </v-text-field>
                                        </v-flex>

                                        <v-flex lg6 xs12 sm6>
                                            <label for="fileFactura" class="v-btn" style="cursor: pointer">
                                                <v-icon class="pr-1">fa fa-cloud-upload</v-icon> Factura
                                            </label>
                                            <input
                                                ref="fileFactura"
                                                id="fileFactura"
                                                type="file"
                                                @change="onChangeFacturaFileUpload()"
                                                accept="image/*,.pdf,.doc,.docx,.txt,.xsl,.xslx"
                                            />
                                            <br />
                                            <div class="error_message">
                                                {{ facturaFileErrors[0] }}
                                            </div>
                                            {{
                                                !solicitudItem.factura.name
                                                    ? "Seleccione un archivo..."
                                                    : solicitudItem.factura.name
                                            }}
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-tab-item>
                            <v-tab-item :key="3" :value="`tab-3`">
                                <v-container fluid grid-list-xl>
                                    <v-layout align-center wrap>
                                        <v-flex lg6 xs12 sm6 v-if="solicitudItem.forma_pago_id === 2">
                                            <v-select
                                                v-model="solicitudItem.banco_id"
                                                :items="BANCOS"
                                                label="Banco*"
                                                item-text="nombre"
                                                item-value="id"
                                                append-outer-icon="add"
                                                @click:append-outer="showBancoForm = true"
                                                :rules="bancoRules"
                                                :error-messages="banco_idErrors"
                                                @change="banco_idErrors = []"
                                            >
                                            </v-select>
                                        </v-flex>
                                        <v-flex
                                            lg6
                                            xs12
                                            sm6
                                            v-if="
                                                solicitudItem.forma_pago_id === 1 || solicitudItem.forma_pago_id === 2
                                            "
                                        >
                                            <v-text-field
                                                v-model="solicitudItem.clave"
                                                :label="
                                                    solicitudItem.forma_pago_id === 1
                                                        ? 'Número de cheque'
                                                        : 'Cuenta o Clave Interbancaria'
                                                "
                                                :rules="claveRules"
                                                :error-messages="claveErrors"
                                                @blur="claveErrors = []"
                                                :counter="20"
                                                ref="cuenta"
                                                name="cuenta"
                                                browser-autocomplete="cuenta"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex lg6 xs12 sm6>
                                            <v-text-field
                                                v-model="solicitudItem.cuenta"
                                                label="Cuenta*"
                                                :rules="cuentaRules"
                                                :error-messages="cuentaErrors"
                                                @blur="cuentaErrors = []"
                                                :counter="18"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex lg6 xs12 sm6>
                                            <label for="fileComprobante" class="v-btn" style="cursor: pointer">
                                                <v-icon class="pr-1">fa fa-cloud-upload</v-icon> Comprobante
                                            </label>
                                            <input
                                                ref="fileComprobante"
                                                id="fileComprobante"
                                                type="file"
                                                @change="onChangeComprobanteFileUpload()"
                                                accept="image/*,.pdf,.doc,.docx,.txt,.xsl,.xslx"
                                            />
                                            <br />
                                            <div class="error_message">
                                                {{ comprobanteFileErrors[0] }}
                                            </div>
                                            {{
                                                solicitudItem.comprobante.length === 0
                                                    ? "Seleccione un archivo..."
                                                    : solicitudItem.comprobante.name
                                            }}
                                        </v-flex>
                                        <v-flex lg6 xs12 sm6>
                                            <v-select
                                                v-model="solicitudItem.categoria_id"
                                                :items="SOLICITUD_PAGO_CATEGORIAS"
                                                label="Categoria"
                                                item-text="categoria"
                                                item-value="id"
                                                append-outer-icon="add"
                                                @click:append-outer="showSolicitudPagoCategoriaForm = true"
                                                :error-messages="categoria_idErrors"
                                                @change="categoria_idErrors = []"
                                                clearable
                                            >
                                            </v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-form>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <small class="ml-2">(*) indica campos requeridos</small>
                    <v-spacer></v-spacer>
                    <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                    <v-btn color="success" flat @click="saveForm()" :disabled="disableSaveButton" :loading="loading"
                        >Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <monto-form
            v-if="showTipoMontoForm"
            form-title="Nuevo Tipo de Monto"
            :initial-item="null"
            @formCanceled="showTipoMontoForm = false"
        >
        </monto-form>
        <pago-form
            v-if="showFormaPagoForm"
            form-title="Nueva Forma de Pago"
            :initial-item="null"
            @formCanceled="showFormaPagoForm = false"
        >
        </pago-form>
        <banco-form
            v-if="showBancoForm"
            form-title="Nuevo Banco"
            :initial-item="null"
            @formCanceled="showBancoForm = false"
        >
        </banco-form>
        <solicitud-pago-categoria-form
            v-if="showSolicitudPagoCategoriaForm"
            form-title="Nueva Categoría"
            :initial-item="null"
            @formCanceled="showSolicitudPagoCategoriaForm = false"
        >
        </solicitud-pago-categoria-form>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import Util from "@/util"
const SolicitudPagoCategoriaForm = () =>
    import("@/components/finanzas/nomencladores/solicitud-pago-categoria-form/solicitud-pago-categoria-form")
const MontoForm = () => import("@/components/finanzas/nomencladores/tipo-monto-form/monto-form")
const PagoForm = () => import("@/components/finanzas/nomencladores/forma-pago-form/pago-form")
const BancoForm = () => import("@/components/finanzas/nomencladores/banco-form/banco-form")

export default {
    name: "SolicitudPagoForm",
    components: {
        SolicitudPagoCategoriaForm,
        BancoForm,
        PagoForm,
        MontoForm
    },
    props: {
        formTitle: { type: String, default: null },
        initialItem: { type: Object, default: null }
    },

    data: () => ({
        loading: false,

        // Formulario de la solicitud
        isValidSolicitud: true,
        solicitudItem: {
            id:"",
            fecha_solicitud: "",
            fecha_pago: "",
            campus_id: null,
            nombre_solicitante: "",
            departamento_id: null,
            concepto_id: null,
            descripcion: "",
            factura: "",
            tipo_monto_id: null,
            monto: null,
            forma_pago_id: null,
            categoria_id: "",
            razon_o_nombre: "",
            banco_id: "",
            cuenta: "",
            clave: "",
            comprobante: ""
        },

        menuFechaSolicitud: false,
        menuFechaPago: false,
        FechaSolicitud: new Date().toISOString().substr(0, 10),
        FechaPago: new Date().toISOString().substr(0, 10),

        activeTab: "tab-1",
        showTipoMontoForm: false,
        showFormaPagoForm: false,
        showBancoForm: false,
        showSolicitudPagoCategoriaForm: false,

        //alert errores de validacion
        showErrorAlert: false,

        fecha_solicitudRules: [v => !!v || "Debe proporcionar la fecha de solicitud."],
        fecha_solicitudErrors: [],
        fecha_pagoRules: [v => !!v || "Debe proporcionar la fecha de pago."],
        fecha_pagoErrors: [],
        campus_idRules: [v => !!v || "Debe proporcionar el campus."],
        campus_idErrors: [],
        departamento_idRules: [v => !!v || "Debe proporcionar el departamento."],
        departamento_idErrors: [],
        concepto_idErrors: [],
        nombre_solicitanteRules: [
            v => !!v || "Debe proporcionar el nombre del solicitante.",
            v => v.length < 256 || "El nombre del solicitante debe contener menos de 255 caracteres."
        ],
        nombre_solicitanteErrors: [],
        tipo_monto_idRules: [v => !!v || "Debe proporcionar el tipo de monto."],
        tipo_monto_idErrors: [],
        montoRules: [v => !!v || "Debe proporcionar el monto."],
        montoErrors: [],
        forma_pago_idRules: [v => !!v || "Debe proporcionar la forma de pago."],
        forma_pago_idErrors: [],
        categoria_idErrors: [],
        razon_o_nombreRules: [
            v => !!v || "Debe proporcionar la razón o el nombre.",
            v => v.length < 256 || "La razón o el nombre debe contener menos de 255 caracteres."
        ],
        razon_o_nombreErrors: [],
        descripcionRules: [
            v => !!v || "Debe proporcionar la descripción.",
            v => v.length < 256 || "La descripción debe contener menos de 255 caracteres."
        ],
        descripcionErrors: [],
        bancoRules: [v => !!v || "Debe proporcionar el banco."],
        banco_idErrors: [],
        cuentaRules: [
            v => !!v || "Debe proporcionar la cuenta.",
            v => v.length < 19 || "La cuenta debe contener menos de 18 caracteres.",
            v => /^\d*$/.test(v) || "La cuenta solo puede contener dígitos."
        ],
        cuentaErrors: [],
        claveRules: [
            v => v.length < 21 || "La clave debe contener menos de 20 caracteres.",
            v => /^\d*$/.test(v) || "La clave solo puede contener dígitos."
        ],
        claveErrors: [],
        facturaFileErrors: [],
        comprobanteFileErrors: [],

        //tipos de formas de pago
        forma_pago_tipos: ["Directa", "Indirecta"],

        //saber si se cargaron todos los datos necesarios para el formulario
        showErrorDataLoadedAlert: false
    }),

    computed: {
        ...mapGetters([
            "CAMPUS",
            "DEPARTAMENTOS",
            "MONTOS",
            "PAGOS",
            "BANCOS",
            "SOLICITUD_PAGO_CATEGORIAS",
            "CONCEPTOS"
        ]),

        isNewRecord() {
            return this.initialItem === null
        },

        showForm: {
            get: function() {
                return true
            },
            set: function() {
                return this.cancelForm()
            }
        },

        disableSaveButton() {
            return (
                this.loading ||
                !this.isValidSolicitud ||
                this.facturaFileErrors.length > 0 ||
                this.comprobanteFileErrors.length > 0
            )
        },

        computedFechaSolicitudFormatted() {
            this.solicitudItem.fecha_solicitud = this.formatDate(this.FechaSolicitud)
            return this.formatDate(this.FechaSolicitud)
        },

        computedFechaPagoFormatted() {
            this.solicitudItem.fecha_pago = this.formatDate(this.FechaPago)
            return this.formatDate(this.FechaPago)
        }
    },

    methods: {
        saveForm() {
            this.loading = true
            this.$refs.solicitudForm.validate()
            if (this.isValidSolicitud) {
                let solicitud = new FormData()

                Object.entries(this.solicitudItem).forEach(([key, value]) => {
                    solicitud.append(key, value)
                })

                if (this.solicitudItem.factura !== "") {
                    solicitud.append("SolicitudPago[file]", this.solicitudItem.factura)
                }
                if (this.solicitudItem.comprobante !== "") {
                    solicitud.append("SolicitudPago[file1]", this.solicitudItem.comprobante)
                }
                if (!this.solicitudItem.categoria_id) {
                    solicitud.append("categoria_id", "")
                }

                if (!this.isNewRecord) {
                    solicitud.append("id", this.initialItem.id)
                }

                this.$store
                    .dispatch(this.isNewRecord ? "ADD_SOLICITUD" : "UPDATE_SOLICITUD", solicitud)
                    .then(result => {
                        if (!result) {
                            this.loading = false
                        }
                        if (result === null || result.status === 404 || result.status === 500) {
                            //cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe o no hay coneccion con el servidor
                            this.$emit("formCanceled")
                        } else {
                            // El backend devolvió error de validación, pasando los errores a los campos correspondientes
                            let { data, status } = result
                            if (status === 422) {
                                this.showErrorAlert = true
                                data.forEach(error => {
                                    switch (error.field) {
                                        case "nombre_solicitante":
                                            this.nombre_solicitanteErrors.push(error.message)
                                            break
                                        case "fecha_solicitud":
                                            this.fecha_solicitudErrors.push(error.message)
                                            break
                                        case "fecha_pago":
                                            this.fecha_pagoErrors.push(error.message)
                                            break
                                        case "campus_id":
                                            this.campus_idErrors.push(error.message)
                                            break
                                        case "departamento_id":
                                            this.departamento_idErrors.push(error.message)
                                            break
                                        case "categoria_id":
                                            this.categoria_idErrors.push(error.message)
                                            break
                                        case "descripcion":
                                            this.descripcionErrors.push(error.message)
                                            break
                                        case "tipo_monto_id":
                                            this.tipo_monto_idErrors.push(error.message)
                                            break
                                        case "monto":
                                            this.montoErrors.push(error.message)
                                            break
                                        case "forma_pago_id":
                                            this.forma_pago_idErrors.push(error.message)
                                            break
                                        case "razon_o_nombre":
                                            this.razon_o_nombreErrors.push(error.message)
                                            break
                                        case "banco_id":
                                            this.banco_idErrors.push(error.message)
                                            break
                                    }
                                    console.log(error.message)
                                })
                            }
                        }
                        this.loading = false
                    })
            } else {
                this.loading = false
            }
        },
        cancelForm() {
            this.$emit("formCanceled")
        },

        formatDate(date) {
            if (!date) return null
            const [year, month, day] = date.split("-")
            return `${day}/${month}/${year}`
        },

        parseDate(date) {
            if (!date) return null
            const [day, month, year] = date.split("/")
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`
        },

        onChangeFacturaFileUpload() {
            this.solicitudItem.factura = this.$refs.fileFactura.files[0]

            if (
                this.solicitudItem.factura !== "" &&
                Util.validateFile(this.solicitudItem.factura.name, ["image", "pdf", "word", "txt", "excel"])
            ) {
                this.facturaFileErrors = []
            } else {
                this.solicitudItem.factura = []
                this.facturaFileErrors.push("El archivo seleccionado debe ser una imagen, pdf , word, txt o excel")
            }
        },

        onChangeComprobanteFileUpload() {
            this.solicitudItem.comprobante = this.$refs.fileComprobante.files[0]

            if (
                this.solicitudItem.comprobante !== "" &&
                Util.validateFile(this.solicitudItem.comprobante.name, ["image", "pdf", "word", "txt", "excel"])
            ) {
                this.comprobanteFileErrors = []
            } else {
                this.solicitudItem.comprobante = []
                this.comprobanteFileErrors.push("El archivo seleccionado debe ser una imagen, pdf o word, txt o excel")
            }
        }
    },

    watch: {
        FechaSolicitud: function() {
            this.solicitudItem.fecha_solicitud = this.formatDate(this.FechaSolicitud)
        }
    },

    created() {
        this.$store.dispatch("LOAD_ALL_CAMPUS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_DEPARTAMENTOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_CONCEPTOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_MONTOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_PAGOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_BANCOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })

        this.$store.dispatch("LOAD_ALL_SOLICITUD_PAGO_CATEGORIAS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })

        if (this.initialItem !== null) {
            this.solicitudItem = Object.assign({}, this.initialItem)

            if (!this.initialItem.banco_id) {
                this.solicitudItem.banco_id = ""
            }
            if (!this.initialItem.concepto_id) {
                this.solicitudItem.concepto_id = ""
            }
            if (!this.initialItem.cuenta) {
                this.solicitudItem.cuenta = ""
            }

            if (!this.initialItem.clave) {
                this.solicitudItem.clave = ""
            }

            if (this.initialItem.campus.length) {
                this.solicitudItem.campus_id = []
                this.initialItem.campus.forEach(campus => this.solicitudItem.campus_id.push(campus.id))
            } else this.solicitudItem.campus_id = []

            if (this.initialItem.factura_real === "null") {
                this.solicitudItem.factura = []
            } else {
                this.solicitudItem.factura = { name: this.initialItem.factura_real }
            }

            if (this.initialItem.comprobante_real === "null") {
                this.solicitudItem.comprobante = []
            } else {
                this.solicitudItem.comprobante = { name: this.initialItem.comprobante_real }
            }

            if (this.initialItem.fecha_solicitud) {
                let [dia, mes, ano] = this.initialItem.fecha_solicitud.split("/")
                this.solicitudItem.fecha_solicitud = ano + "-" + mes + "-" + dia
                this.FechaSolicitud = this.solicitudItem.fecha_solicitud
            }

            if (this.initialItem.fecha_pago) {
                let [dia, mes, ano] = this.initialItem.fecha_pago.split("/")
                this.solicitudItem.fecha_pago = ano + "-" + mes + "-" + dia
                this.FechaPago = this.solicitudItem.fecha_pago
            }

            if (!this.initialItem.categoria_id) {
                this.solicitudItem.categoria_id = ""
            }
        }
    }
}
</script>

<style scoped>
.v-alert {
    padding-top: 3px;
    padding-bottom: 4px;
    margin-top: 1px;
    margin-left: 2px;
    margin-right: 2px;
}

input[type="file"] {
    display: none;
}

.error_message {
    font-size: 12px;
    color: #ff5252;
    caret-color: #ff5252;
}
</style>
